import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import NewInvoiceModal from "../../../../invoice/newmodal.component.jsx"
import AccountLimit from "../../../../state/account-limit/AccountLimit"
import GlobalHelper from "../../../GlobalHelper"
import Icon from "../../../icon/icon.component.jsx"
import ButtonWrapper from "../../../rich-text/feature-protection-wrappers/buttonProtectionWrapper.component"

interface OwnProps {
    accountLimits: AccountLimit
    recurring?: boolean
    contactId?: string
}

const InvoiceCreationButton = (props: OwnProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = (id?: string) => {
        setOpenModal(false)

        if (id) {
            window.location.href = `/invoices/${id}/edit`
        }
    }

    return (
        <>
            {openModal && (
                <NewInvoiceModal
                    recurring={props.recurring}
                    onClose={handleCloseModal}
                    contactId={props.contactId}
                />
            )}
            <ButtonWrapper
                message={
                    GlobalHelper.isAccountLimitExceeded(props.accountLimits.getDto())
                        ? <FormattedMessage
                            id="generic-listing.document-limit-exceeded"
                            defaultMessage="Documents limit exceeded."
                        />
                        : ""
                }
                onClick={handleOpenModal}
                className="btn btn-primary"
                protectedClassName="btn btn-primary"
                protectionRule={!GlobalHelper.isAccountLimitExceeded(props.accountLimits.getDto())}
            >
                <span>
                    <Icon value="plus-circle" />
                    {props.recurring ? (
                        <FormattedMessage
                            id="generic-listing.subscriptions.create-btn-text"
                            defaultMessage="New subscription"
                        />
                    ) : (
                        <FormattedMessage
                            id="generic-listing.invoices.create-btn-text"
                            defaultMessage="New invoice"
                        />
                    )}
                </span>
            </ButtonWrapper>
        </>
    )
}

export default InvoiceCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/InvoiceCreationButton.tsx